module.exports = __webpack_public_path__ + "static/media/m6tj0.19db51da.png";